import { render, staticRenderFns } from "./__ReturnModal.vue?vue&type=template&id=f50caf10&"
import script from "./__ReturnModal.vue?vue&type=script&lang=js&"
export * from "./__ReturnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports